

var theWindow ; 


(function ($) {
theWindow = $(window);

// theWindow.trigger("window:resize");

setTimeout(() => {
  document.body.classList.remove("preload");

}, 500);


$(window).resize(function() {
  document.body.classList.add("resizing")
  clearTimeout(window.resizedFinished);
  window.resizedFinished = setTimeout(function(){
    document.body.classList.remove("resizing")
  }, 250);
});

var resizeTimer; // Set resizeTimer to empty so it resets on page load

function resizeFunction() {
    $(window).on('resize', function() {
      theWindow.trigger("window:resize");
  });
};

resizeFunction();



  ///////////////////////////////////////////////////////////////////////////
  //Randomize                                       
  ///////////////////////////////////////////////////////////////////////////

  $.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function () {
        $(this).children(selector).sort(function (childA, childB) {
            // * Prevent last slide from being reordered
            if($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};









var opacityLevel = 10;

  
$('.lessOpacity').on('click', function(){
  opacityLevel--
  $('.tracingTemplate img').css('opacity', opacityLevel/10 )
})
$('.moreOpacity').on('click', function(){
  opacityLevel++
  $('.tracingTemplate img').css('opacity', opacityLevel/10)
})



})(jQuery); // or even jQuery.noConflict()






(function ($) {

  $.fn.designGuides = function (options, callback) {

    var settings = $.extend({
      show: false
    }, options)


    var pathname = window.location.pathname.split('/')[1].split('.')[0];
    if(pathname.length == 0){
      $('body').append(' <div class="templatePlacer">   <div class="buttons">    <button class="opacityUp">+</button>      <button class="opacityDown">-</button>    <span class="checkBox">    <input type="checkbox" name="template">   Template </span> <span class="checkBox"> <input type="checkbox" name="menu"> Menu </span> <span class="checkBox"><input type="checkbox" name="login">Login</span><span class="checkBox guides"><input type="checkbox" name="guides" checked>Guides</span><div class="opacityCounter">Opacity<span class="opacity">0</span></div> </div> <figure class="theTemplate template">      <img src="images/template/home.jpg" alt="template"/>      </figure>   <figure class="theTemplate menu">   <img src="images/template/menu.png" alt="template"/>   </figure>  <figure class="theTemplate login"> <img src="images/template/login.png" alt="template"/></figure><div class="margin1 active" style="opacity:0;"></div><div class="margin2 active" style="opacity:0;"></div></div>')

    }else{
    $('body').append(' <div class="templatePlacer">   <div class="buttons">    <button class="opacityUp">+</button>      <button class="opacityDown">-</button>    <span class="checkBox">    <input type="checkbox" name="template">   Template </span> <span class="checkBox"> <input type="checkbox" name="menu"> Menu </span> <span class="checkBox"><input type="checkbox" name="login">Login</span><span class="checkBox guides"><input type="checkbox" name="guides" checked>Guides</span><div class="opacityCounter">Opacity<span class="opacity">0</span></div> </div> <figure class="theTemplate template">      <img src="images/template/'+pathname+'.jpg" alt="template"/>      </figure>   <figure class="theTemplate menu">   <img src="images/template/menu.png" alt="template"/>   </figure>  <figure class="theTemplate login"> <img src="images/template/login.png" alt="template"/></figure><div class="margin1 active" style="opacity:0;"></div><div class="margin2 active" style="opacity:0;"></div></div>')

    } 
    $('body').append('');


    var counter = 1;
    $('.opacityUp').on('click', function(){
      if(counter <= 9 && $('.active').length > 0){
        counter++;
        $('.active').css('opacity', counter/10);
        $('.opacity').html(counter);
      }


    })

    $('.opacityDown').on('click', function(){
      if(counter >= 1 && $('.active').length > 0){
        counter--;
        $('.active').css('opacity', counter/10);
        $('.opacity').html(counter);
      }
      
    })

    $('input:checkbox[name="template"]').on('click', function(){
        var styles = $('.active').css('opacity');
      if ($('input:checkbox[name="template"]').is(':checked')) {
        
        $('.theTemplate.template').addClass('active').css('opacity', styles);;
        
      }else{
        $('.theTemplate.template').removeClass('active');
      }
    })

    $('input:checkbox[name="menu"]').on('click', function(){
      var styles = $('.active').css('opacity');
      if ($('input:checkbox[name="menu"]').is(':checked')) {
        $('.theTemplate.menu').addClass('active').css('opacity', styles);
      }else{
        $('.theTemplate.menu').removeClass('active');
      }
    })


    $('input:checkbox[name="login"]').on('click', function(){
    var styles = $('.active').css('opacity');
    if ($('input:checkbox[name="login"]').is(':checked')) {
      $('.theTemplate.login').addClass('active').css('opacity', styles);
    }else{
      $('.theTemplate.login').removeClass('active');
    }
  })


  $('input:checkbox[name="guides"]').on('click', function(){
    var styles = $('.theTemplate.active').css('opacity');
    if ($('input:checkbox[name="guides"]').is(':checked')) {
      $('.margin1, .margin2').show().css('opacity', styles);
    }else{
      $('.margin1, .margin2').hide();
    }
  })
  

    //toggle templates
    // $('.changeTemplate').on('click', function(){
    //     var styles = $('.theTemplate.active').css('opacity');
    //     var active = $('.theTemplate.active');
    //     var next = active.next()
        
    //     active.removeClass('active').css('opacity', 0);
    //     if(next.length === 0) {
    //       $('.theTemplate').first().addClass('active').css('opacity', styles);
    //     }else{
    //       next.addClass('active').css('opacity', styles);
    //     }
    // })


  }

})(jQuery); // or even jQuery.noConflict()



